<template>
  <div class="d-flex flex-column">
    <div class="subcategory d-flex flex-column justify-space-around align-center py-5">
      <SubcategoryButton
        icon="wb_incandescent"
        color="#FF00FF"
        text="Lights Didn't Turn Off"
      />
      <SubcategoryButton
        icon="wb_incandescent"
        text="Lights Didn't Turn On"
      />
      <SubcategoryButton
        icon="more_horiz"
        text="Other"
      />
    </div>
  </div>
</template>

<script>
import SubcategoryButton from '@/components/repairTickets/SubcategorySelection/SubcategoryButton.vue';

export default {
  name: 'IrrigationSubcategorySelection',
  components: {
    SubcategoryButton,
  },
  methods: {},
};
</script>

<style lang="scss"></style>
